import { configureStore, createSlice } from '@reduxjs/toolkit';

// Auth Slice
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    isAuthenticated: false,
    freeDocsUsed: 0,
    freeDocsLimit: 5,
    showAuthModal: false,
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.showAuthModal = false;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    incrementUsage: (state) => {
      state.freeDocsUsed += 1;
    },
    setShowAuthModal: (state, action) => {
      state.showAuthModal = action.payload;
    },
  },
});

// Files Slice
const filesSlice = createSlice({
  name: 'files',
  initialState: {
    uploadedFiles: [],
    processedFiles: [],
    currentFile: null,
    isProcessing: false,
    progress: 0,
    history: [],
  },
  reducers: {
    addFiles: (state, action) => {
      state.uploadedFiles = [...state.uploadedFiles, ...action.payload];
    },
    removeFile: (state, action) => {
      state.uploadedFiles = state.uploadedFiles.filter((_, i) => i !== action.payload);
    },
    clearFiles: (state) => {
      state.uploadedFiles = [];
      state.processedFiles = [];
      state.currentFile = null;
    },
    setCurrentFile: (state, action) => {
      state.currentFile = action.payload;
    },
    setProcessing: (state, action) => {
      state.isProcessing = action.payload;
    },
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    addToHistory: (state, action) => {
      state.history.unshift({
        ...action.payload,
        timestamp: Date.now(),
        id: `hist_${Date.now()}`,
      });
    },
    addProcessedFile: (state, action) => {
      state.processedFiles.push(action.payload);
    },
  },
});

// UI Slice
const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    darkMode: false,
    sidebarOpen: false,
    commandPaletteOpen: false,
    currentTool: null,
    viewMode: 'grid',
    activeCategory: null,
    toasts: [],
    mobileMenuOpen: false,
  },
  reducers: {
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setCommandPalette: (state, action) => {
      state.commandPaletteOpen = action.payload;
    },
    setCurrentTool: (state, action) => {
      state.currentTool = action.payload;
    },
    setViewMode: (state, action) => {
      state.viewMode = action.payload;
    },
    setActiveCategory: (state, action) => {
      state.activeCategory = action.payload;
    },
    addToast: (state, action) => {
      state.toasts.push({ id: Date.now(), ...action.payload });
    },
    removeToast: (state, action) => {
      state.toasts = state.toasts.filter(t => t.id !== action.payload);
    },
    setMobileMenuOpen: (state, action) => {
      state.mobileMenuOpen = action.payload;
    },
  },
});

export const authActions = authSlice.actions;
export const filesActions = filesSlice.actions;
export const uiActions = uiSlice.actions;

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    files: filesSlice.reducer,
    ui: uiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
